import { appUrl } from 'utils/wrappers';

import PageableBase from 'app/collections/pageable_base';
import Shipment from 'app/models/shipment';

export default PageableBase.extend({
  model: Shipment,
  key: 'shipments',
  url: appUrl('shipments'),
});



// WEBPACK FOOTER //
// ./app/collections/shipments.js